import React, { useContext, useEffect, useState } from "react";
import PageTabs from "../Components/PageTabs";
import Transaction from "../../API/APIServices/Transaction";
import Swal from "sweetalert2";
import MyContext from "../MyContext";
import Loader from "../Props/Loader";
import Account from "../../API/APIServices/Account";
import Transporter from "../../API/APIServices/Transporter";

const TransportModal = ({ OpenTModal, item, reportAttachTo }) => {
  const [showDlt, setshoDlt] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transportnamedropdown, settransportnamedrop] = useState([]);
  const [formData, setFormData] = useState({
    Date: { label: "Date", type: "date", value: "" },
    TransportName: { label: "Transport Name", type: "text", value: "" },
    DocLandingRRLR: { label: "Document / RR / LR", type: "text", value: "" },
    TransIdGSTIN: { label: "Transport ID / GSTIN", type: "text", value: "" },
    TransportMode: { label: "Transport Mode", type: "text", value: "" },
    DistanceKm: { label: "Distance (Km)", type: "number", value: "" },
    VehicleNo: { label: "Vehicle Number", type: "text", value: "" },
    VehicleType: { label: "Vehicle Type", type: "text", value: "" },
  });
  console.log(item);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: { ...formData[e.target.name], value: e.target.value },
    });
  };

  const handleSave = async () => {
    ;
    setLoading(true);
    const currentDate = new Date(Date.now());
    const formattedDate = `${currentDate.getFullYear()}/${
      currentDate.getMonth() + 1
    }/${currentDate.getDate()}`;

    const data = {
      mastType: reportAttachTo,
      transId: item?.id || "",
      transp_Id: 0,
      transp_Name: item?.partyName || "",
      doc_No: formData.DocLandingRRLR.value,
      gst_No: formData.TransIdGSTIN.value,
      vehical_No: parseInt(formData.VehicleType.value),
      distance: `${formData.DistanceKm.value}km`,
      mode: formData.TransportMode.value,
      vehical_Type: parseInt(formData.VehicleType.value),
      eF1: "string",
      eF2: "string",
      eF3: "string",
      eF4: "string",
      eF5: "string",
      transp_Date: formData.Date.value,
      createdBy: 0,
      createdOn: formattedDate,
    };

    try {
      const result = await Transaction.CreateInvoiceTransport(data);
      console.log("Save result:", result);
      if (result) {
        console.log("Save successful:", result);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Transport details saved successfully!",
          confirmButtonText: "OK",
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        }).then(() => {
          OpenTModal();
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Data is not saved",
          confirmButtonText: "OK",
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
      }
    } catch (error) {
      console.error("Save failed:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Data is not saved due to an error",
        confirmButtonText: "OK",
        customClass: {
          title: "swal2-custom-title",
          confirmButton: "my-confirm-button",
          cancelButton: "my-cancel-button",
          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    OpenTModal();
  };

  useEffect(() => {
    const fetchtransportModal = async (trans1Id) => {
      try {
        setLoading(true);
        const data = await Transaction.GetInvoiceTransport(trans1Id);
        if (data) {
          console.log(`data`, data);
          setFormData(() => {
            return {
              Date: { label: "Date", type: "date", value: data?.transp_Date },
              TransportName: {
                label: "Transport Name",
                type: "text",
                value: data?.transp_Name,
              },
              DocLandingRRLR: {
                label: "Document / RR / LR",
                type: "text",
                value: data?.doc_No,
              },
              TransIdGSTIN: {
                label: "Transport ID / GSTIN",
                type: "text",
                value: data?.gst_No,
              },
              TransportMode: {
                label: "Transport Mode",
                type: "text",
                value: data?.mode,
              },
              DistanceKm: {
                label: "Distance (Km)",
                type: "number",
                value: data?.distance.slice(0, -2),
              },
              VehicleNo: {
                label: "Vehicle Number",
                type: "text",
                value: data?.vehical_No,
              },
              VehicleType: {
                label: "Vehicle Type",
                type: "text",
                value: data?.vehical_Type,
              },
            };
          });
          setshoDlt(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchtransportModal(item?.id);
  }, []);

  const handledelete = async () => {
    if (!item) {
      return;
    }
    try {
      const response = await Transaction.DeleteInvoiceTransport(item?.id || 0);
      if (response?.length != 0) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.errorMessages[0],
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          width: "250px",
          customClass: {
            title: "swal2-custom-title",
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Deleted Successfully",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          width: "250px",
          customClass: {
            title: "swal2-custom-title",
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
        OpenTModal();
      }
      console.log("Delete response", response);
    } catch (error) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",
          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    }
  };

  const handleInputFocus = async (label, data) => {
    if (label == "TransportName") {
      const transport = await Transporter.GetTransporter();
      if (transport) {
        console.log(transport);
        settransportnamedrop(transport);
      }
    }
  };

  const handleOnblur = () => {
    settransportnamedrop([]);
  };

  const handledropdownset = (item, label) => {
    if (item) {
      setFormData((prev) => ({
        ...prev,
        TransportName: {
          label: "Transport Name",
          type: "text",
          value: item?.name || "",
        },
        DocLandingRRLR: {
          label: "Document / RR / LR",
          type: "text",
          value: item?.docLandingRR_LR || "",
        },
        TransIdGSTIN: {
          label: "Transport ID / GSTIN",
          type: "text",
          value: item?.transporterGSTIN || "",
        },
        TransportMode: {
          label: "Transport Mode",
          type: "text",
          value:
            item?.transportationMode == "Air"
              ? 3
              : item?.transportationMode == "Road"
              ? 1
              : item?.transportationMode == "Rail"
              ? 2
              : item?.transportationMode == "Ship"
              ? 4
              : "",
        },
        VehicleNo: {
          label: "Vehicle Number",
          type: "text",
          value: item?.vehicleNo || "",
        },
        VehicleType: {
          label: "Vehicle Type",
          type: "text",
          value: item?.vehicleType == "" || "",
        },
      }));
    }
  };

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content-transport">
          <h2 className={`transport-modal`}>Transport Details</h2>
          <form className={`form-tag`}>
            {Object.entries(formData).map(([label, value]) => (
              <div className="form-group" key={label}>
                <label>{value.label.replace(/([A-Z])/g, " $1").trim()}</label>
                {/* -------select--------- */}
                {label == "TransportMode" && (
                  <>
                    <select
                      name={label}
                      value={value.value}
                      onChange={handleChange}
                    >
                      <option value={"select"}>--select--</option>
                      <option value={1}>Road</option>
                      <option value={2}>Rail</option>
                      <option value={3}>Air</option>
                      <option value={4}>Ship</option>
                    </select>
                  </>
                )}

                {label == "VehicleType" && (
                  <>
                    <select
                      name={label}
                      value={value.value}
                      onChange={handleChange}
                    >
                      <option value={"select"}>--select--</option>
                      <option value={1}>Regular</option>
                      <option value={2}>ODC</option>
                    </select>
                  </>
                )}
                {label != "VehicleType" && label != "TransportMode" && (
                  <div className={`dropdown-data`}>
                    <input
                      type={value.type}
                      name={label}
                      onFocus={() => handleInputFocus(label, value)}
                      value={value.value}
                      onChange={handleChange}
                    />
                    {label == "TransportName" &&
                      transportnamedropdown.length != 0 && (
                        <>
                          <ul style={{ zIndex: "21" }} className={`ul-drop`}>
                            {transportnamedropdown.map((item) => {
                              return (
                                <li
                                  onClick={(e) =>
                                    handledropdownset(item, label)
                                  }
                                >
                                  {item.name}
                                </li>
                              );
                            })}
                          </ul>
                          <div
                            onClick={(e) => handleOnblur(e)}
                            style={{
                              background: "transparent",
                              position: "absolute",
                              zIndex: "10",
                              width: "100vw",
                              height: "100vh",
                            }}
                            className={``}
                          ></div>
                        </>
                      )}
                  </div>
                )}
              </div>
            ))}
          </form>
          <div className="modal-buttons">
            <div className={`modal-button-first`}>
              <button
                className={`close-transport close-butoon-transport`}
                onClick={handleClose}
              >
                <span style={{ marginRight: "5px" }}>
                  <i class="fa fa-window-close" aria-hidden="true"></i>
                </span>
                Close
              </button>
              {showDlt && (
                <button className={`close-transport`} onClick={handledelete}>
                  <span style={{ marginRight: "5px" }}>
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </span>
                  Delete
                </button>
              )}
            </div>
            <button className={`save-transport`} onClick={handleSave}>
              <span style={{ marginRight: "5px" }}>
                <i class="fas fa-save"></i>
              </span>
              Save & Share
            </button>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </>
  );
};

export default TransportModal;
